__webpack_require__.p = "/wp-content/plugins/rbs-vlb-reservations/build/";